import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import "./PreviewImage.css";

interface IProp {
    dataUrl: string
}

const PreviewImage = observer((prop: IProp) => {
    // memo : useState values can read next iteration.
    //        I need to use the value in onClick function, so to use this value,
    //        set the next time valid value.
    const [needExpand, setNeedExpand] = useState<boolean>(true);
    const [imgClass, setImgClass] = useState<string>("PreviewImage-img");
    //let isExpand = false;
    console.log(`creating preview image isExpand = ${needExpand}`);

    const previewImage = <img
        className={imgClass} src={prop.dataUrl} key="dummy" alt={needExpand.toString()}
        onClick={() => {
            console.log(needExpand);
            if (needExpand) {
                setImgClass("PreviewImage-img-expand")
            }
            else {
                setImgClass("PreviewImage-img")
            }
            // if change the value with setXX, the value is not change in this loop
            setNeedExpand(!needExpand);
        }}
    />;

    return previewImage;
});

export default PreviewImage;